import React, { useContext } from "react"; // Removed useState and useEffect as they are no longer needed for this logic
import { NavLink } from "react-router-dom";
import {
  AppBar,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import DevicesIcon from "@mui/icons-material/Devices";
import StoreIcon from "@mui/icons-material/Store";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import CategoryIcon from "@mui/icons-material/Category";
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
import SelectBox from "./SelectBox";
import { InfoContext } from "../context/InfoContext";

const drawerWidth = 240;

const menuItems = [
  { text: "Gruppi Negozi", icon: <GroupWorkIcon />, path: "/sp/store-groups" },
  { text: "Negozi", icon: <StoreIcon />, path: "/sp/stores" },
  { text: "Gruppi dispositivi", icon: <CategoryIcon />, path: "/sp/device-groups" },
  { text: "Tipi Dispositivo", icon: <DisplaySettingsIcon />, path: "/sp/device-types" },
  { text: "Dispositivi", icon: <DevicesIcon />, path: "/sp/devices" },
];

function AppLayout({ children }) {
  const { info, setInfo } = useContext(InfoContext);

  // FIX 1: Derive 'clienti' directly from the 'info' prop on every render.
  // This ensures the options are always up-to-date if 'info' is loaded asynchronously.
  const clienti = Array.isArray(info?.utenti)
    ? info.utenti.map((cliente) => ({
        key: cliente.client_id,
        value: cliente.nome_cliente,
      }))
    : [];


  const handleClientChange = (selectedItems) => {
    // selectedItems is an array from SelectBox
    if (selectedItems && selectedItems.length > 0) {
      const selectedClientData = selectedItems[0]; // Get the first item
      // Find the full client object from the original info array.
      const foundClient = info?.utenti?.find(
        (cliente) => cliente.client_id === selectedClientData.key
      );

      if (foundClient) {
        // FIX 2: Update the context with the ENTIRE client object.
        // The rest of your app can now access all details of the selected client.
        setInfo((prevInfo) => ({
          ...prevInfo,
          selectedClient: foundClient,
        }));
      }
    } else {
      // Handle the case where the selection is cleared
      setInfo((prevInfo) => ({
        ...prevInfo,
        selectedClient: null,
      }));
    }
  };

  // FIX 3: Derive the value for the SelectBox directly from the context.
  // This removes the need for local state (useState, useEffect) and simplifies the component.
  const selectedClientForSelectBox = info?.selectedClient
    ? [
        {
          key: info.selectedClient.client_id,
          value: info.selectedClient.nome_cliente,
        },
      ]
    : [];

  return (
    <Box
      sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#f5f6fa" }}
    >
      <AppBar
        position="fixed"
        elevation={1}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
            Pannello di Controllo SP
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
              Seleziona Cliente
            </Typography>
            <SelectBox
              options={clienti}
              onSelectionChange={handleClientChange}
              // Pass the derived value directly as the 'initialSelected' prop.
              // SelectBox's internal useEffect will handle updating the display when this prop changes.
              initialSelected={selectedClientForSelectBox}
              label="Cliente" // The SelectBox component expects a label prop.
            />
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
            backgroundColor: "#fff",
            borderRight: "1px solid #e0e0e0",
          },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: "auto", mt: 2 }}>
          <List>
            {menuItems.map((item) => (
              <ListItem key={item.text} disablePadding>
                <ListItemButton
                  component={NavLink}
                  to={item.path}
                  sx={{
                    "&.active": {
                      backgroundColor: "#e3f2fd",
                      "& .MuiListItemIcon-root": { color: "#1976d2" },
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: "#757575" }}>
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, sm: 3 },
          backgroundColor: "#f5f6fa",
          minHeight: "100vh",
        }}
      >
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
}

export default AppLayout;
